<template>
<form :class="bem([innerType, extraCls, hideFooterCls])" @submit.prevent :style="`width: ${width}px`">
    <OtherWaySwitchLogin :type="innerType"/>
    <PhoneLogin type="pwd" v-if="innerType === 'phone'" />
    <PhoneLogin type="sms" v-else-if="innerType == 'smsLogin'" />
    <EmailLogin type="email" v-else-if="innerType == 'email'" />
    <EmailLogin type="email-code" v-else-if="innerType == 'emailCode'" />
    <Wechat v-else-if="innerType === 'wechat'" :QRCodeCaption="wechatQRCodeCaption" />
    <Register v-else-if="innerType == 'register'" />
    <Resetpwd v-else-if="innerType == 'resetpwd'" />
    <BindPhone v-else-if="innerType == 'bindphone'" />
    <BindPhoneQiye :bindInfo="qiyeBindInfo" v-else-if="innerType == 'bindphoneqiye'" />
    <BreakloginQiye v-else-if="innerType == 'breakloginQiye'"/>
    <ThirdLogin :thirdToken="thirdToken" v-else-if="innerType == 'third-login'" />
    <Wechat v-else :QRCodeCaption="wechatQRCodeCaption" />
    <slot name="footer" v-if="!hideFooter && showFooter">
        <Footer />
    </slot>
</form>

</template>
<script>
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bemMixin from './bem';
import OtherWaySwitchLogin from './OtherWaySwitchLogin.vue';
import PhoneLogin from './phone.vue';
import EmailLogin from './email.vue';
import Wechat from './wechat.vue';
import Register from './register.vue';
import Resetpwd from './resetpwd.vue';
import BindPhone from './bindphone.vue';
import BindPhoneQiye from './bindphone-qiye.vue';
import BreakloginQiye from './breaklogin-qiye.vue';
import ThirdLogin from './third-login.vue';
import Footer from './Footer.vue';
import request from './request';
import { DEFAULT_SITE_TYPE, LOGIN_TYPE, SET_LAST_LOGIN_TYPE, GET_LAST_LOGIN_TYPE } from './constants';
import { getConfig, getQywechatAuthUri } from './config';
import qs from 'qs';
import guestUser from './guestUser'; // import { Message } from '@gaoding/gdui';

import { createOAuth2Client } from './oauth2-client';

function getQueryParams(url) {
  var result = {};
  var param = /([^?=&]+)=([^&]+)/gi;
  var match;

  while ((match = param.exec(url)) != null) {
    result[match[1]] = match[2];
  }

  return result;
}

function hasProp(vm, key) {
  if (!vm.$options.propsData) return false;
  return key in vm.$options.propsData && vm.$options.propsData[key] !== undefined;
}

export default {
  name: 'g-auth',
  components: {
    OtherWaySwitchLogin: OtherWaySwitchLogin,
    PhoneLogin: PhoneLogin,
    EmailLogin: EmailLogin,
    Register: Register,
    Wechat: Wechat,
    ThirdLogin: ThirdLogin,
    Resetpwd: Resetpwd,
    BindPhone: BindPhone,
    BindPhoneQiye: BindPhoneQiye,
    BreakloginQiye: BreakloginQiye,
    Footer: Footer
  },
  mixins: [bemMixin],
  provide: function provide() {
    return {
      vm: this
    };
  },
  props: {
    type: {
      type: String,
      default: 'wechat'
    },
    defaultType: {
      type: String,
      default: 'wechat'
    },
    thirdToken: {
      type: String,
      default: ''
    },
    extraCls: {
      type: String,
      default: ''
    },
    loginWays: {
      type: Array,
      default: function _default() {
        return ['wechat', 'phone', 'qq', 'register', 'qiyeWechat'];
      }
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 447
    },
    wechatQRCodeCaption: String,
    siteType: {
      type: String,
      default: DEFAULT_SITE_TYPE
    },
    deviceName: {
      type: String,
      default: ''
    },
    canaryTag: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _this = this;

    var type = 'wechat';
    var hideFooterCls = this.hideFooter ? 'hide-footer' : '';
    if (hasProp(this, 'type')) type = this.type;else if (hasProp(this, 'defaultType')) type = this.defaultType;

    if (this.lastLoginType) {
      type = this.lastLoginType; // @FIX Safari

      setTimeout(function () {
        _this.$emit('update:type', type);
      }, 0);
    }

    if (!type) throw new Error('无效的type属性');
    return {
      loading: true,
      inited: false,
      countries: [{
        name: '中国',
        code: 86
      }, {
        name: '中国香港',
        code: 852
      }, {
        name: '中国澳门',
        code: 853
      }, {
        name: '中国台湾地区',
        code: 886
      }],
      form: {
        phone: {
          number: '',
          code: 86
        },
        password: '',
        verifyCode: ''
      },
      formEmail: {
        email: '',
        password: '',
        verifyCode: ''
      },
      innerType: type,
      hideFooterCls: hideFooterCls,
      bindphoneType: '',
      currentUser: null,
      QQRedirect: null,
      QQRedirectCloseTimer: null,
      QiyeWechatRedirect: null,
      QiyeWechatRedirectCloseTimer: null,
      qiyeBindInfo: null
    };
  },
  computed: {
    showFooter: function showFooter() {
      return !['bindphone', 'breakloginQiye'].includes(this.innerType);
    }
  },
  watch: {
    type: function type(value) {
      this.innerType = value;
      this.form.password = '';
      this.form.verifyCode = '';
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.oauth2Client = createOAuth2Client();
              _this2.lastLoginType = GET_LAST_LOGIN_TYPE(_this2.oauth2Client, function (lastLoginType) {
                _this2.switchType(lastLoginType);
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    // this.oauth2Client = createOAuth2Client();
    this.createIframe();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyIframe();

    if (this.QQRedirect) {
      clearTimeout(this.QQRedirectCloseTimer);
      window.removeEventListener('message', this.listenQQAuthorizationMessage, false);
    }

    if (this.QiyeWechatRedirect) {
      clearTimeout(this.QiyeWechatRedirectCloseTimer);
      window.removeEventListener('message', this.listenQiyeWechatAuthorizationMessage, false);
    }
  },
  methods: {
    createIframe: function createIframe() {
      var iframe = document.querySelector('#ums');
      var src = this.getIframeSrc();
      this.loading = true;

      if (iframe) {
        iframe.src += '';
        return;
      }

      iframe = document.createElement('iframe');
      iframe.setAttribute('id', 'ums');
      iframe.setAttribute('frameborder', 0);
      iframe.setAttribute('style', 'display:none');
      iframe.setAttribute('src', src);
      iframe.onload = this.onIframeLoad;
      document.body.appendChild(iframe);
      this.ums = iframe.contentWindow;
    },
    destroyIframe: function destroyIframe() {
      var iframe = document.querySelector('#ums');

      if (iframe) {
        iframe.parentNode.removeChild(iframe);
      }
    },
    getIframeSrc: function getIframeSrc() {
      if (this.src) {
        return this.src;
      }

      var query = getQueryParams(location.href) || {};

      var state = _objectSpread(_objectSpread({}, getConfig('extendState')), {}, {
        last_screen_width: window.screen.width,
        last_screen_height: window.screen.height
      });

      if (guestUser.guestfinger) {
        state.guest_token = guestUser.guestfinger;
      }

      if (query && query.hmsr) {
        state.source = query.hmsr;
      }

      if (this.deviceName) {
        state.deviceName = this.deviceName;
      }

      if (this.canaryTag) {
        state.canaryTag = this.canaryTag;
      }

      var encodedState = encodeURIComponent(qs.stringify(state));
      this.src = this.oauth2Client.authorizationRedirectURI(encodedState, _objectSpread(_objectSpread({
        biz_code: getConfig('bizCode')
      }, query), getConfig('extendQuery')));
      return this.src;
    },
    onIframeLoad: function onIframeLoad() {
      this.loading = false;
      this.init();
    },
    init: function init() {
      var _this3 = this;

      if (this.inited) {
        return;
      }

      this.requestUms('getCountries').then(function (data) {
        var list = _this3.countries;
        data.forEach(function (c) {
          list = list.concat(c.list.filter(function (n) {
            return !n.name.includes('中国');
          }));
        });
        list.forEach(function (c) {
          c.code = parseInt(c.code);
        });
        _this3.countries = list;
        _this3.inited = true;
      }); // 安全策略原因：不支持快捷登录
      // this.requestUms('getCurrentUser').then(user => {
      //     this.currentUser = user;
      // });
    },
    switchType: function switchType(type) {
      if (type === this.innerType) return;
      this.lastType = this.innerType;

      if (hasProp(this, 'type')) {
        this.$emit('update:type', type);
      } else {
        this.innerType = type;
        this.form.password = '';
        this.form.verifyCode = '';
      }
    },
    onLogin: function onLogin(type) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var timer = null;

        var callback = function callback(event) {
          var data = event.data;
          var env = getConfig('env');
          var sso = getConfig('sso');
          console.log('auth login', event, env);

          if (['dev', 'fat'].includes(env)) {
            console.log('listen login postmessage:', data);
          }

          if (!data.action || !data.action.startsWith('login')) {
            return;
          }

          window.removeEventListener('message', callback);
          clearTimeout(timer);
          console.log(data.data, 'login.success');

          if (sso) {
            _this4.$emit('success', {
              action: 'login',
              type: type,
              data: data
            });

            resolve();
            return;
          }

          _this4.oauth2Client.login(data.data).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!(type === LOGIN_TYPE.QIYE_WECHAT || type === LOGIN_TYPE.QIYE_WECHAT_BINDPHONE)) {
                      _context2.next = 3;
                      break;
                    }

                    _context2.next = 3;
                    return _this4.oauth2Client.launchreRreshOrgIdFlow();

                  case 3:
                    if (!(_this4.siteType !== DEFAULT_SITE_TYPE)) {
                      _context2.next = 7;
                      break;
                    }

                    // 无需调用 /api/users/me 接口
                    _this4.$emit('success', {
                      action: 'login',
                      type: type,
                      data: data.data
                    });

                    SET_LAST_LOGIN_TYPE(_this4.oauth2Client, _this4.innerType);
                    return _context2.abrupt("return");

                  case 7:
                    request.get("".concat(getConfig('gaodingURL'), "/api/users/me"), {
                      withCredentials: true
                    }).then(function (res) {
                      var user = res.data;

                      _this4.$emit('success', {
                        action: 'login',
                        type: type,
                        data: user
                      });

                      SET_LAST_LOGIN_TYPE(_this4.oauth2Client, _this4.innerType);
                      resolve();
                    }).catch(function (error) {
                      _this4.$emit('error', {
                        action: 'login',
                        type: type,
                        error: error
                      });

                      _this4.createIframe();

                      reject(error);
                    });

                  case 8:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })));
        };

        timer = setTimeout(function () {
          window.removeEventListener('message', callback);
          clearTimeout(timer);
          var error = new Error('网络超时');

          _this4.$emit('error', {
            action: 'login',
            type: type,
            error: error
          });

          _this4.createIframe();

          reject(error);
        }, 20000);
        window.addEventListener('message', callback, false);
      });
    },
    requestUms: function requestUms(action) {
      var _this5 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      Object.assign(headers, {
        'Accept-Language': 'zh-CN,zh;q=0.9',
        'X-Guest-Token': guestUser.guestfinger,
        'X-Biz-Code': getConfig('bizCode')
      });
      return new Promise(function (resolve) {
        if (_this5.loading) {
          var unwatch = _this5.$watch('loading', function () {
            unwatch();
            resolve();
          });
        } else {
          resolve();
        }
      }).then(function () {
        var timer = null;
        return new Promise(function (resolve, reject) {
          var callback = function callback(event) {
            console.log('callback event', event);

            if (event.data.action !== action + '.success' && event.data.action !== action + '.error') {
              return false;
            }

            if (event.data.action === action + '.success') {
              resolve(event.data.data);
            } else {
              var error = new Error(event.data.data.message);

              if (event.data.data.code) {
                error.status = event.data.data.code;
              }

              if (event.data.data.error_code) {
                error.error_code = event.data.data.error_code;
              }

              reject(error);
            }

            clearTimeout(timer);
            window.removeEventListener('message', callback);
          }; // TODO ums 需要处理


          if (headers && headers['X-Guest-Token']) {
            data.guestToken = headers['X-Guest-Token'];
          } else if (guestUser.guestfinger) {
            data.guestToken = guestUser.guestfinger;
          }

          timer = setTimeout(function () {
            reject(new Error('网络超时'));
            window.removeEventListener('message', callback);
          }, 20000);
          window.addEventListener('message', callback);

          _this5.ums.postMessage({
            action: action,
            data: data,
            headers: headers
          }, '*');
        });
      });
    },
    launchQQAuthorizationFlow: function launchQQAuthorizationFlow() {
      var _this6 = this;

      if (this.QQRedirect && !this.QQRedirect.closed) {
        this.QQRedirect.focus();
        return;
      }

      var QQRedirectURI = getConfig('QQRedirectURI');
      var features = 'status=no,resizable=no,scrollbars=yes,personalbar=no,directories=no,location=no,toolbar=no,menubar=no,width=886,height=500,left=0,top=0'; // this.$emit('update:type', 'qq');

      this.QQRedirect = window.open(QQRedirectURI, '', features);
      window.addEventListener('message', this.listenQQAuthorizationMessage, false);

      if (this.QQRedirect) {
        this.QQRedirectCloseTimer = setTimeout(function () {
          return _this6.listenQQRedirectClose();
        }, 100);
      }
    },
    listenQQAuthorizationMessage: function listenQQAuthorizationMessage(event) {
      var _this7 = this;

      var data = event.data;

      if (!data) {
        return;
      }

      if (!['login.success', 'bindphone'].includes(data.action)) {
        return;
      }

      var type = data.data && data.data.type;

      if (type !== 'qq') {
        return;
      }

      if (data.action === 'login.success') {
        this.requestUms('authorizationCodeLogin', {
          code: data.data.authorization_code
        }).then(function () {
          _this7.onLogin('qq');
        }).catch(function (error) {
          _this7.$emit('error', {
            error: error,
            action: 'login',
            type: 'qq'
          });
        }); // this.switchType(this.lastType);
      } else if (data.action === 'bindphone') {
        this.bindphoneType = 'qq';
        this.switchType('bindphone');
      }

      clearTimeout(this.QQRedirectCloseTimer);
      this.QQRedirectCloseTimer = null;
      window.removeEventListener('message', this.listenQQAuthorizationMessage, false);
      this.QQRedirect && this.QQRedirect.close();
      this.QQRedirect = null;
    },
    listenQQRedirectClose: function listenQQRedirectClose() {
      var _this8 = this;

      if (this.QQRedirect.closed) {
        window.removeEventListener('message', this.listenQQAuthorizationMessage, false);
        this.QQRedirect = null;
        this.QQRedirectCloseTimer = null;
        return;
      }

      this.QQRedirectCloseTimer = setTimeout(function () {
        return _this8.listenQQRedirectClose();
      }, 100);
    },

    /**
     * 企业微信登录
     */
    launchQiyeWechatAuthorizationFlow: function launchQiyeWechatAuthorizationFlow() {
      var _this9 = this;

      if (this.QiyeWechatRedirect && !this.QiyeWechatRedirect.closed) {
        this.QiyeWechatRedirect.focus();
        return;
      }

      var features = 'status=no,resizable=no,scrollbars=yes,personalbar=no,directories=no,location=no,toolbar=no,menubar=no,width=886,height=500,left=0,top=0';
      var QiyeWechatRedirectURI = getQywechatAuthUri(); // this.$emit('update:type', 'qiyeWechat');

      this.QiyeWechatRedirect = window.open(QiyeWechatRedirectURI, '', features);
      window.addEventListener('message', this.listenQiyeWechatAuthorizationMessage, false);

      if (this.QiyeWechatRedirect) {
        this.QiyeWechatRedirectCloseTimer = setTimeout(function () {
          return _this9.listenQiyeWechatRedirectClose();
        }, 100);
      }
    },
    listenQiyeWechatRedirectClose: function listenQiyeWechatRedirectClose() {
      var _this10 = this;

      if (this.QiyeWechatRedirect.closed) {
        window.removeEventListener('message', this.listenQiyeWechatAuthorizationMessage, false);
        this.QiyeWechatRedirect = null;
        this.QiyeWechatRedirectCloseTimer = null;
        return;
      }

      this.QiyeWechatRedirectCloseTimer = setTimeout(function () {
        return _this10.listenQiyeWechatRedirectClose();
      }, 100);
    },
    listenQiyeWechatAuthorizationMessage: function listenQiyeWechatAuthorizationMessage(event) {
      var data = event.data;

      if (!data) {
        return;
      }

      if (['queryWechatStatus.success'].includes(data.action)) {
        return;
      }

      this.resloveQiyeWechatAuthorization(data);
      clearTimeout(this.QiyeWechatRedirectCloseTimer);
      this.QiyeWechatRedirectCloseTimer = null;
      window.removeEventListener('message', this.listenQiyeWechatAuthorizationMessage, false);
      this.QiyeWechatRedirect && this.QiyeWechatRedirect.close();
      this.QiyeWechatRedirect = null;
    },
    launchQiyeWechatFromCode: function launchQiyeWechatFromCode() {
      var _this11 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.requestUms('launchQiyeWechatFromCode', Object.assign({
        guestToken: guestUser.guestfinger,
        client_id: getConfig('clientId')
      }, data)).then(function (res) {
        _this11.resloveQiyeWechatAuthorization(res);
      });
    },
    resloveQiyeWechatAuthorization: function resloveQiyeWechatAuthorization(data) {
      var _this12 = this;

      console.log('auth qiyeWechat login', data);
      var info = JSON.parse(data).data;

      if (info.redirect_code === '40031') {
        // 企业微信首次授权登录，完善信息，填写手机和验证码
        this.qiyeBindInfo = info;
        this.switchType('bindphoneqiye');
      } else if (info.redirect_code === '40030') {
        // 企业微信未授权
        this.switchType('breakloginQiye');
      } else if (info.access_token) {
        this.requestUms('authorizationQiyeWechatLogin', info).then(function () {
          _this12.onLogin(LOGIN_TYPE.QIYE_WECHAT);
        });
      } else {
        this.$emit('error', {
          error: new Error(info.message),
          action: 'login',
          type: 'qiyeWechat'
        });
      }
    },
    launchAuthFromCode: function launchAuthFromCode() {
      var _this13 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.requestUms('launchAuthFromCode', Object.assign({
        guestToken: guestUser.guestfinger,
        client_id: getConfig('clientId')
      }, data), headers).then(function () {
        _this13.onLogin(LOGIN_TYPE.AUTH_CODE);
      });
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth {
  font-family: PingFang SC;
  position: relative;
  height: 480px;
  padding-top: 80px;
  background: #fff;
}
.g-auth--hide-footer {
  padding: 58px 0 10px 0;
}
.g-auth * {
  box-sizing: border-box;
}
.g-auth .g-auth--qq {
  display: none;
}

</style>
